var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.444 9.47307L19.774 19.4731C19.6613 20.1687 19.3072 20.8024 18.774 21.2631C18.2062 21.7168 17.5008 21.9636 16.774 21.9631H7.16402C6.46134 21.9569 5.78312 21.7043 5.24766 21.2492C4.71219 20.7941 4.35346 20.1656 4.23402 19.4731L2.56402 9.47307C2.47358 8.8961 2.55352 8.30527 2.79402 7.77307C3.03445 7.24361 3.42356 6.79544 3.91402 6.48307L10.394 2.48307C10.8675 2.19103 11.4128 2.03638 11.969 2.03638C12.5253 2.03638 13.0706 2.19103 13.544 2.48307L20.014 6.48307C20.521 6.78307 20.925 7.23007 21.174 7.76307C21.4301 8.29415 21.524 8.88892 21.444 9.47307Z",
    fill: "url(#paint0_linear_1025_188)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1025_188",
    x1: 2.52783,
    y1: 11.9997,
    x2: 21.4718,
    y2: 11.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F466C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.e941eadd5a22a3ab7ae38f6eeb7475f2.svg";
export { ForwardRef as ReactComponent };